import { useState } from 'react';
import { generateUID } from '../../utils/uniqueId';

export const useUniqueId = (): string => {
  const [id] = useState(generateUID);

  return id;
};
